import styled from"@emotion/styled";import{Modal,AntdSelect as Select}from"@wp/src/components/common";import Input from"@wp/src/components/common/input/Input";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{css}from"@emotion/react";import{AmountInput}from"@wp/src/components/screenComponents/portfolio/investmentsManager/investmentUpsertForm/atoms";import*as React from"react";import{Body2W400Neutral500}from"@wp/src/components/common/atoms";import{useResponsiveScreenWidth}from"@wp/src/components/common/responsive/useResponsive";import Switch from"@wp/src/components/common/switch";export const StyledNetworthCurrencySelect=styled(Select)`
  width: 110px;
`;export const RealEstateSelectContainer=styled.div`
  min-width: 120px;
  flex-basis: 49%;
`;export const RealEstateSelect=styled(Select)`
  width: 100%;
`;export const StyledNetworthInput=styled(AmountInput)`
  ${props=>props.isInvalid?css`
          border: 1px solid ${props.theme.colors.antRed5};
        `:""}

  :hover {
    border-color: ${props=>props.isInvalid&&props.theme.colors.antRed5};
  }
`;export const PopupAmountContainer=styled.div`
  padding: 16px 0 16px 0;
`;export const _StyledNetworthAssetPopup=styled(Modal)`
  .ant-modal-title {
    font-size: 20px;
  }

  .ant-modal-body {
    padding: 4px 0;
  }
`;export const RealEstateNicknameInput=styled(Input)`
  width: 100%;
`;export const PrivateEquityNameInput=styled(Input)`
  width: 100%;
`;export const PrivateEquityTypeSelect=styled(RealEstateSelect)`
  ${mediaQuery({width:["100%"]})}
`;export const RealEstatePincodeInput=styled(Input)`
  min-width: 120px;
  ${mediaQuery({width:["100%"]})}
`;export const RealEstatePropertyTypeSelect=styled(RealEstateSelect)``;export const RealEstateRentalPropertySwitch=styled(Switch)``;export const NetworthItemSecondaryText=styled(Body2W400Neutral500)`
  color: ${props=>props.theme.colors.neutral500};
`;export const NetworthItemSecondaryDetailsContainer=props=>{return React.createElement(NetworthItemSecondaryText,null,React.createElement(FlexLayout,{flexDirection:"row",itemsSpacingHorizontal:12,justifyContent:"flex-start"},props.children))};export const NetworthItemMainContentContainer=props=>{const{isBelow576}=useResponsiveScreenWidth();return React.createElement(FlexLayout,{justifyContent:"flex-start",itemsSpacingHorizontal:isBelow576?0:12,itemsSpacingVertical:isBelow576?12:0},props.children)};